var map = {
	"./IOS_logo.svg": "0e0b",
	"./MacOS_logo.svg": "06cb",
	"./about.jpg": "a46c",
	"./about2.jpg": "14ca",
	"./android-logo.svg": "0e3d",
	"./banner-bcg.png": "f859",
	"./bcg-offer.jpg": "77b3",
	"./cia_logo_color.svg": "2613",
	"./cia_logo_white.svg": "54d0",
	"./icons/cookies.svg": "4a01",
	"./icons/icon-3d_print.svg": "16f2",
	"./icons/icon-3d_scan.svg": "5f4c",
	"./icons/icon-access.svg": "3cd3",
	"./icons/icon-adress.svg": "3afc",
	"./icons/icon-app.svg": "a2d5",
	"./icons/icon-clients.svg": "fae0",
	"./icons/icon-cloud.svg": "4b00",
	"./icons/icon-destroy.svg": "352b",
	"./icons/icon-docs.svg": "e565",
	"./icons/icon-docs2.svg": "5622",
	"./icons/icon-email.svg": "477a",
	"./icons/icon-format.svg": "3555",
	"./icons/icon-innovation.svg": "3cd4",
	"./icons/icon-phone.svg": "3ff5",
	"./icons/icon-stats.svg": "373e",
	"./ue.jpg": "d0c7",
	"./windows_logo.svg": "7bd9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";